import request from './base'

export const companyList = (params) => {
    return request.post("/admin/v1/company/list", params)
}

export const companyInfo = (params) => {
    return request.post("/admin/v1/company/info", params)
}

export const companyAdd = (params) => {
    return request.post("/admin/v1/company/add", params)
}

export const companyModify = (params) => {
    return request.post("/admin/v1/company/modify", params)
}

export const companyCreateAppKey = (params) => {
    return request.post("/admin/v1/company/createAppKey", params)
}

export const companyDelete = (params) => {
    return request.post("/admin/v1/company/delete", params)
}


export const companySelect = () => {
    return request.post("/admin/v1/company/select")
}

export const companyCarList = (params) => {
    return request.post("/admin/v1/company/car/list", params)
}

export const companyCarAdd = (params) => {
    return request.post("/admin/v1/company/car/add", params)
}

export const companyCarModify = (params) => {
    return request.post("/admin/v1/company/car/modify", params)
}

export const companyCarDelete = (params) => {
    return request.post("/admin/v1/company/car/delete", params)
}

export const companyCarUnbind = (params) => {
    return request.post("/admin/v1/company/car/unbind", params)
}

export const companyMapList = (params) => {
    return request.post("/admin/v1/company/map/list", params)
}

export const searchCompanyByName = (params) => {
    return request.post("/admin/v1/company/map/searchCompanyByName", params)
}



// WEBPACK FOOTER //
// ./src/api/company.js